import { render, staticRenderFns } from "./chayi.vue?vue&type=template&id=35ab699b&scoped=true&"
import script from "./chayi.vue?vue&type=script&lang=ts&"
export * from "./chayi.vue?vue&type=script&lang=ts&"
import style0 from "./chayi.vue?vue&type=style&index=0&id=35ab699b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ab699b",
  null
  
)

export default component.exports